import { Navigate, useLocation } from "react-router-dom";
import { useCurrentUser } from "@/lib/auth";
import { CardSkeleton } from "@/components/Skeleton";

export default function AuthGate({ children }: { children: React.ReactNode }) {
  const { user, isLoading } = useCurrentUser();
  const loc = useLocation();
  // Выкидываем на логин только когда пользователя действительно нет.
  // Ошибка фоновой ревалидации при живом кеше (сетевой сбой, 502 во время
  // деплоя) — не разлогин: иначе / и /login зацикливаются в редирект-пинг-понг.
  if (user) return <>{children}</>;
  if (isLoading)
    return (
      <div className="p-8 max-w-md" aria-busy="true">
        <CardSkeleton />
      </div>
    );
  return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
}
